export default {
    translation: {
    LOGIN:"Giriş Yap"
    }
}